import Vue from 'vue'
import JsonApiObject from '@/_models/JsonApi'

import ProjectModel from '@/views/Project/Project/models/project'
import ModuleModel from '@/views/Project/Project/models/module'

import ModulePatch from '@/views/Project/Project/dialogs/modulePatch/modulePatch.vue'
import ModuleBklr from '@/views/Project/Project/dialogs/moduleBklr/moduleBklr.vue'

import store from '@/store'

export default class ProjectModuleModel extends JsonApiObject {
    static statuses = ['active', 'archived', 'closed', 'deleted']

    static async post(data: any) {
        let query = {
            body: { data: data },
        }

        let res = await Vue.prototype.$vbit
            .post('project', `projectModules`, query)
            .catch((error) => {
                return this.handleProjectError(error)
            })

        return res.data ? res.data : res
    }

    static handleProjectError(error) {
        if (error.code) store.commit('closeSnackbar')

        return {
            type: 'error',
            code: error.code ? error.code : null,
            text: error.code ? `fe_project.error_${error.code}` : null,
        }
    }

    isAccessible
    status
    retentionPeriod
    deletionAt
    createdAt
    updatedAt

    get project(): ProjectModel {
        return this._relationships['project'] ? this._relationships['project'] : null
    }

    get module(): ModuleModel {
        return this._relationships['module'] ? this._relationships['module'] : null
    }

    public constructor(data: any, included?) {
        super(data, included)
    }

    async initBklrInfo() {
        return await JsonApiObject.openDialog(ModuleBklr, {})
    }

    async initPatch(project: ProjectModel, projectModule: ProjectModuleModel, status: string) {
        return await JsonApiObject.openDialog(ModulePatch, { project, projectModule, status })
    }

    async patch(status: string) {
        let query = {
            updatedAt: this['updatedAt'],
            body: {
                data: {
                    type: this._type,
                    id: this._id,
                    attributes: {
                        status: status,
                    },
                },
            },
        }

        let res = await Vue.prototype.$vbit.patch('project', `projectModules/${this._id}`, query)

        if (res.data) {
            this.initalize(res.data, res.included)
            // Temporary solution to update modules
            store.commit('projectModule', res.data)
        }
        return res
    }
}
